import { useSelector } from 'react-redux';
import {
    ChannelType,
    getActiveScreen,
    getCategories,
    getProductMap,
} from 'src/modules/Redux';
import { getChannelOptions } from '../utils';
import { useAppSelector } from 'src/modules/Redux/store';
import { NormalizedIProduct } from '@snackpass/snackpass-types';

const MAX_ITEMS = 30;

export function useSortProducts() {
    const screen = useSelector(getActiveScreen);
    const options = getChannelOptions(ChannelType.InfiniteScrollImage, screen);

    const categories = useAppSelector(getCategories);
    const productMap = useAppSelector(getProductMap);

    const pinnedProducts = options.getOrDefault('pinnedProducts', []);
    const pinnedCategories = options.getOrDefault('pinnedCategories', []);
    const shouldHideSoldOut = options.getOrDefault('hideSoldOut', false);

    const products: NormalizedIProduct[] = [];
    categories.forEach(category => {
        category.productIds.forEach(productId => {
            products.push({
                ...(productMap[productId] as NormalizedIProduct),
            });
        });
    });

    const sortedProducts = products.filter(p => {
        if (shouldHideSoldOut && p.soldOut) {
            return false;
        }
        if (!pinnedProducts.length && !pinnedCategories.length) {
            return true;
        }

        return (
            (pinnedProducts.length &&
                pinnedProducts.some(pp => pp.productId === p._id)) ||
            (pinnedCategories.length &&
                pinnedCategories.some(pc => pc.category === p.category))
        );
    });

    return sortedProducts.slice(0, MAX_ITEMS);
}
